import { CalendarClock, CalendarPlus, FileText, History, Home, Megaphone, Activity } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Navegação do PAN.
 *
 * No monorepo essa lista vivia fora do app: era publicada como itens de
 * launcher (`@launcher/menu.json`) no ERPrompt-API e lida em runtime pelo
 * `TemplateNavigation`. Aqui ela é código da própria aplicação — versionada
 * junto das rotas que descreve, sem passo de publicação.
 *
 * Lista plana, sem rótulos de grupo. O playbook prevê grupo como rótulo (filete
 * azul + contagem) para módulos com muitas sub-abas — o caso que originou a
 * regra tinha 18. Com sete itens, o agrupamento só acrescenta duas linhas de
 * cabeçalho e um degrau de leitura entre itens que já cabem numa olhada.
 *
 * `bloqueado` NUNCA remove o item do menu — ele aparece com cadeado e o motivo,
 * para o usuário entender que o módulo existe e por que não pode entrar.
 */

export interface ItemNavegacao {
  id: string;
  rotulo: string;
  rota: string;
  icone: LucideIcon;
  descricao: string;
  /** Motivo do bloqueio; `null` = liberado. */
  bloqueado?: string | null;
}

export const navegacao: ItemNavegacao[] = [
  {
    id: 'home',
    rotulo: 'Visão geral',
    rota: '/home',
    icone: Home,
    descricao: 'Escopo, saúde e próximos agendamentos',
  },
  {
    id: 'versao-saude',
    rotulo: 'Versão e saúde',
    rota: '/versao-saude',
    icone: Activity,
    descricao: 'Versão atual, recomendada e estado de cada instalação',
  },
  {
    id: 'contratos',
    rotulo: 'Contratos',
    rota: '/contratos',
    icone: FileText,
    descricao: 'Cliente, status do contrato e módulos contratados',
  },
  {
    id: 'agendar',
    rotulo: 'Agendar atualização',
    rota: '/agendar',
    icone: CalendarPlus,
    descricao: 'Escolher instalações, versão, data e horário',
  },
  {
    id: 'agendamentos',
    rotulo: 'Agendamentos',
    rota: '/agendamentos',
    icone: CalendarClock,
    descricao: 'Tudo que está programado ou foi cancelado',
  },
  {
    id: 'historico',
    rotulo: 'Histórico',
    rota: '/historico',
    icone: History,
    descricao: 'Atualizações concluídas, falhas e cancelamentos',
  },
  {
    id: 'novidades',
    rotulo: 'Novidades',
    rota: '/novidades',
    icone: Megaphone,
    descricao: 'O que mudou em cada versão, por módulo',
  },
];

/** Capabilities que dão acesso a QUALQUER seção da Administração — cada seção
 * dentro do modal ainda confere a sua própria (ver `AdministracaoDialog`).
 * "Administração" não é um item da sidebar — é um modal aberto pelo
 * dropdown do usuário (`UserChip`), visível só pra quem tem alguma delas. */
export const CAPABILITIES_ADMINISTRACAO = ['admin', 'estado-instalacao', 'sysadmin', 'sre'];

export function podeAdministracao(roles: string[]): boolean {
  return CAPABILITIES_ADMINISTRACAO.some((role) => roles.includes(role));
}
